"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectFormik = void 0;
var React = require("react");
var react_select_1 = require("react-select");
var creatable_1 = require("react-select/creatable");
var __1 = require("..");
var Theme_1 = require("../../Theme");
var colourStyles = {
    control: function (styles, _a) {
        var isDisabled = _a.isDisabled;
        return (__assign(__assign({}, styles), { backgroundColor: "white", opacity: isDisabled ? 0.4 : 1 }));
    },
    option: function (styles, _a) {
        var isSelected = _a.isSelected;
        return (__assign(__assign({}, styles), { color: isSelected ? Theme_1.Color.StarRezBrandColors.WhiteSR : Theme_1.Color.Grey.G80 }));
    },
    dropdownIndicator: function (styles) { return (__assign(__assign({}, styles), { color: Theme_1.Color.Grey.G70 })); },
};
exports.MultiSelectFormik = React.forwardRef(function (_a, ref) {
    var Autocomplete = _a.Autocomplete, Name = _a.Name, FormikProps = _a.FormikProps, Label = _a.Label, HelperText = _a.HelperText, Disabled = _a.Disabled, ShowRequired = _a.ShowRequired, Placeholder = _a.Placeholder, Options = _a.Options, _b = _a.IsMultiSelect, IsMultiSelect = _b === void 0 ? true : _b, CloseMenuOnSelect = _a.CloseMenuOnSelect, AllowFreeText = _a.AllowFreeText, _c = _a.OnValidateFreeText, OnValidateFreeText = _c === void 0 ? function () { return true; } : _c, _d = _a.FormatFreeTextLabel, FormatFreeTextLabel = _d === void 0 ? function (input) { return "Add \"" + input + "\""; } : _d;
    var Input = React.useCallback(function (props) {
        return React.createElement(react_select_1.components.Input, __assign({}, props, { autoComplete: Autocomplete !== null && Autocomplete !== void 0 ? Autocomplete : "off" }));
    }, []);
    return React.createElement(__1.FormikWrapper, { Label: Label, HelperText: HelperText, Name: Name, FormikProps: FormikProps, Disabled: Disabled, ShowRequired: ShowRequired, RenderControl: function (_, _a, hasErrors) {
            var field = _a.field, form = _a.form;
            var selectProps = {
                "aria-label": Label + " " + HelperText,
                "closeMenuOnSelect": CloseMenuOnSelect !== undefined ? CloseMenuOnSelect : !IsMultiSelect,
                "formatCreateLabel": FormatFreeTextLabel,
                "inputId": Name,
                "isDisabled": Disabled,
                "isMulti": IsMultiSelect,
                "isValidNewOption": OnValidateFreeText,
                "name": field.name,
                "onBlur": function () { return form.setFieldTouched(field.name, true); },
                "onChange": function (option) { return form.setFieldValue(field.name, option); },
                "options": Options,
                "placeholder": Placeholder,
                "ref": ref,
                "styles": colourStyles,
                "theme": function (theme) { return (__assign(__assign({}, theme), { borderRadius: 5, colors: __assign(__assign({}, theme.colors), { neutral20: hasErrors ? Theme_1.Color.Red.R60 : Theme_1.Color.Grey.G30, neutral50: Theme_1.Color.Grey.G80 }), spacing: __assign(__assign({}, theme.spacing), { controlHeight: 40 }) })); },
                "value": field.value,
            };
            return (React.createElement("div", { style: { fontSize: "14px" } }, AllowFreeText ? React.createElement(creatable_1.default, __assign({}, selectProps, { components: { Input: Input } })) : React.createElement(react_select_1.default, __assign({}, selectProps, { components: { Input: Input } }))));
        } });
});
